// import React, { useState } from 'react';
// import './Footer.css'
// import Terms from '../Policy/Terms'
// import Modal from '../Policy/Modal'

// const Footer = () => {
//   const [isTermsOpen, setIsTermsOpen] = useState(false);
//   const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

//   return (
//     <div className='footer'>
//       <div className='page-content'>
//       <p>© 2024 4klabs. All Rights Reserved.</p>
//       <ul>
//         <li>
//           <button onClick={() => setIsTermsOpen(true)} className="link-button2">
//             Terms of Service
//           </button>
//         </li>
//         <li>
//           <button onClick={() => setIsPrivacyOpen(true)} className="link-button2">
//             Privacy Policy
//           </button>
//         </li>
//       </ul>
//       </div>

//       <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)}>
//         <Terms section="terms" />
//       </Modal>

//       <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)}>
//         <Terms section="privacy" />
//       </Modal>
//     </div>
//   );
// };

// export default Footer;





const Footer = () => (
  <footer className="bg-[#3a3a3a] text-[#e0e0e0] text-center py-6">
    <p>&copy; 2025 B & G Fitness. All Rights Reserved.</p>
  </footer>
);

export default Footer;